export default {
    symbolsKeyValue: "Abc",
    layout: [
        ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"],
        ["a", "s", "d", "f", "g", "h", "j", "k", "l"],
        ["z", "x", "c", "v", "b", "n", "m", ".", "_", "-", "+"]
    ],
    specialKeysLayout: ["@gmail.com", "@yahoo.com", "@hotmail.com", "@", ".com"]
};
